'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { SelectionSetContext } from './selection-set.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';

function _define_property(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = n, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {}, r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), r.forEach(function(t) {
            _define_property(e, t, n[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        n.push.apply(n, r);
    }
    return n;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var n, r, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(r = 0; r < l.length; r++)n = l[r], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var n, r, o = {}, l = Object.keys(e);
    for(r = 0; r < l.length; r++)n = l[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
    return o;
}
function isSingleSelect(e) {
    return 'single-select' === e.variant || null == e.variant;
}
let removeSelectionProps = (e)=>{
    if (isSingleSelect(e)) {
        let { selectedValue: t, onSelectedValueChange: n, defaultSelectedValue: r } = e;
        return _object_without_properties(e, [
            "selectedValue",
            "onSelectedValueChange",
            "defaultSelectedValue"
        ]);
    }
    {
        let { selectedValues: t, onSelectedValuesChange: n, defaultSelectedValues: r } = e;
        return _object_without_properties(e, [
            "selectedValues",
            "onSelectedValuesChange",
            "defaultSelectedValues"
        ]);
    }
}, useSelectionState = (e)=>{
    let t, n, r, l;
    let i = null;
    isSingleSelect(e) && (t = e.selectedValue, n = e.onSelectedValueChange, i = e.defaultSelectedValue);
    let [a, c] = useControllableValue({
        value: null != t ? t : void 0,
        onChange: null != n ? n : void 0,
        defaultValue: null != i ? i : null,
        defaultOnChange: (e, ...t)=>{
            let [n] = t;
            e(n);
        }
    }), s = null;
    isSingleSelect(e) || (r = e.selectedValues, l = e.onSelectedValuesChange, s = e.defaultSelectedValues);
    let [u, d] = useControllableValue({
        value: null != r ? r : void 0,
        onChange: null != l ? l : void 0,
        defaultValue: null != s ? s : {},
        defaultOnChange: (e, ...t)=>{
            let [n] = t;
            e(n);
        }
    });
    return {
        selectedValue: a,
        onSelectedValueChange: c,
        selectedValues: u,
        onSelectedValuesChange: d
    };
};
const SelectionSet = renderWithRef('SelectionSet', null, (n, o)=>{
    useComponentStylesLoaded('SelectionSet', SWAN_STYLE_KEY_MAP.selectionSet);
    let c = removeSelectionProps(n), { children: s, variant: u = 'single-select', skin: d = 'standard', imageWidth: p = 'fixed', imageVerticalAlignment: f = 'cover', tileContentsPadding: g = 'standard', tileImagePadding: b = 'standard', name: m } = c, S = _object_without_properties(c, [
        "children",
        "variant",
        "skin",
        "imageWidth",
        "imageVerticalAlignment",
        "tileContentsPadding",
        "tileImagePadding",
        "name"
    ]), O = new Set([
        'swan-selection-set'
    ]);
    'standard' !== d && O.add(`swan-selection-set-skin-${d}`), 'simple-column' === d && O.add('swan-selection-set-show-inputs'), 'proportional' === p && O.add('swan-selection-set-image-width-proportional'), 'center' === f && O.add('swan-selection-set-image-vertical-alignment-center'), 'tight' === g && O.add('swan-selection-set-tile-contents-padding-tight'), 'wide' === b && O.add('swan-selection-set-tile-image-padding-wide');
    let _ = useId(m), { selectedValue: w, onSelectedValueChange: h, selectedValues: j, onSelectedValuesChange: y } = useSelectionState(n), v = _object_spread_props(_object_spread({}, S), {
        role: 'single-select' === u ? 'radiogroup' : 'group'
    });
    return jsx(SelectionSetContext.Provider, {
        value: {
            name: _,
            variant: u,
            skin: d,
            imageWidth: p,
            imageVerticalAlignment: f,
            tileContentsPadding: g,
            tileImagePadding: b,
            selectedValue: w,
            onSelectedValueChange: h,
            selectedValues: j,
            onSelectedValuesChange: y
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: o,
            classNames: O,
            props: v,
            children: s
        })
    });
});

export { SelectionSet };
